var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('m-input',{staticClass:"search-form-field",attrs:{"nolabel":"","placeholder":_vm.$t('search.cargotype')},model:{value:(_vm.search.CARGOTYPENAME),callback:function ($$v) {_vm.$set(_vm.search, "CARGOTYPENAME", $$v)},expression:"search.CARGOTYPENAME"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }